import React, { FC } from "react";
import { COLOR_BLACK } from "../colors";
import { IconType } from "./types";

export const ArrowCurvedDownIcon: FC<IconType> = ({
  color = COLOR_BLACK,
}) => (
  <svg
    width="12"
    height="7"
    viewBox="0 0 12 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 6L7.06568 2.06568C6.86768 1.86768 6.76867 1.76867 6.65451 1.73158C6.55409 1.69895 6.44591 1.69895 6.34549 1.73158C6.23133 1.76867 6.13232 1.86768 5.93431 2.06569L4.56568 3.43432C4.36768 3.63232 4.26867 3.73133 4.15451 3.76842C4.05409 3.80105 3.94591 3.80105 3.84549 3.76842C3.73133 3.73133 3.63232 3.63232 3.43431 3.43431L1 1M11 6H7.5M11 6V2.5"
      stroke={color}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
